var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.2 31.8",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M14.5,2.7c-0.1,0-0.2,0.1-0.2,0.2v0.5c0,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.2-0.2V2.9C14.7,2.8,14.6,2.7,14.5,2.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M14,2.2h-0.5c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2H14c0.1,0,0.2-0.1,0.2-0.2S14.1,2.2,14,2.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M14.5,1.3c-0.1,0-0.2,0.1-0.2,0.2V2c0,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.2-0.2V1.5C14.7,1.4,14.6,1.3,14.5,1.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M15.5,2.2H15c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2h0.5c0.1,0,0.2-0.1,0.2-0.2S15.6,2.2,15.5,2.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M35.6,26.4c-0.2,0-0.3,0.2-0.3,0.3v0.8c0,0.2,0.1,0.3,0.3,0.3s0.3-0.2,0.3-0.3v-0.8 C36,26.6,35.8,26.4,35.6,26.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M34.8,25.6H34c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h0.8c0.2,0,0.3-0.1,0.3-0.3S35,25.6,34.8,25.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M35.6,23.9c-0.2,0-0.3,0.2-0.3,0.3V25c0,0.2,0.1,0.3,0.3,0.3s0.3-0.2,0.3-0.3v-0.8C36,24.1,35.8,23.9,35.6,23.9 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M37.3,25.6h-0.8c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h0.8c0.2,0,0.3-0.1,0.3-0.3S37.5,25.6,37.3,25.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M2,18.7c0,0,0.3,1.9-2,1.9c0,0,2,0,1.9,1.8c0,0,0.2-1.4,2-1.8C3.9,20.7,2.4,21.1,2,18.7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent2",
    d: "M33.2,5.4c0,0,0.3,1.9-2,1.9c0,0,2,0,1.9,1.8c0,0,0.2-1.4,2-1.8C35.1,7.4,33.6,7.8,33.2,5.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent2",
    d: "M5,30c0,0,0.1,1.1-1.1,1.1c0,0,1,0,1,1c0,0,0.1-0.8,1.1-1C6,31.1,5.2,31.3,5,30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M6,10.6c0,0,0.1,0.6-0.6,0.6c0,0,0.6,0,0.6,0.6c0,0,0.1-0.5,0.6-0.6C6.7,11.3,6.2,11.4,6,10.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "emailGreenCheckBkg",
    d: "M16.8,17.1c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9c0-0.8-0.3-1.5-0.9-2.1c-0.5-0.5-1.3-0.9-2.1-0.8 C18.1,14.2,16.8,15.5,16.8,17.1z M19.6,18.6l-1.2-1.3l0.4-0.4l0.8,0.8l1.3-2l0.4,0.3C21.3,16,19.6,18.6,19.6,18.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1",
    d: "M14,8.6c-0.3,0.3-0.5,0.7-0.4,1.1v11.5l1.8,1.5c-0.2-0.4-0.3-0.9-0.3-1.4V10.8c0-1,0.4-1.9,1-2.6H15 C14.7,8.2,14.3,8.3,14,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1",
    d: "M15,7.3c0,0-0.2,0-0.2,0c-0.2,0-0.4,0.1-0.6,0.1C14.5,7.3,14.7,7.3,15,7.3z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1",
    d: "M30.4,29.6c-0.1,0.1-0.3,0.1-0.6,0.1l0.4,0.4C30.3,29.9,30.3,29.7,30.4,29.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1",
    d: "M8.5,18.1L8.3,18v11.1c0,0.3,0.1,0.6,0.2,0.9l1.6-1.5v-9.1L8.5,18.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1",
    d: "M28.5,31.2c0.4,0,0.8-0.2,1.1-0.4l-1.2-1.2H11.7c-0.6,0-1,0-1.3-0.1l-1.3,1.3c0.3,0.3,0.7,0.4,1.1,0.4H28.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "emailAccent1",
    d: "M28.5,31.9H10.2c-0.2,0-0.3,0-0.5,0c0.2,0.1,0.5,0.1,0.8,0.1h17.8c0.1,0,0.3-0.1,0.4-0.1 C28.6,31.9,28.6,31.9,28.5,31.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M24.2,12.1h-1.1c-0.7,0-1.2-0.7-1.2-1.5V9.2c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1 c-0.2,0-0.3,0.2-0.3,0.4v1.3c0,0.6,0.2,1.2,0.5,1.6s0.8,0.7,1.3,0.7h1c0.1,0,0.3-0.2,0.3-0.4S24.3,12.1,24.2,12.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "emailSecondaryBrad",
    d: "M31,16.6l-4.4-3.7v1l3.6,3l-3.6,3L26,20.4V9.6c0-1.3-1-2.3-2.3-2.3H15c-0.6,0-1.2,0.2-1.7,0.7 c-0.4,0.4-0.7,1-0.7,1.6v10.8L12,19.9l-3.6-3l3.6-3v-1l-4.3,3.6c-0.1,0.1-0.2,0.2-0.2,0.4v12.3c0,1.5,1.2,2.7,2.7,2.7h18.3 c1.5,0,2.7-1.2,2.7-2.7V16.9C31.2,16.8,31.1,16.7,31,16.6z M14,8.6c0.3-0.3,0.7-0.4,1-0.4h8.6c0.8,0,1.5,0.7,1.5,1.5v11.5L20.6,25 c-0.7,0.6-1.7,0.6-2.4,0l-4.6-3.8V9.7C13.5,9.3,13.7,8.9,14,8.6z M30.4,29.2c0,0.3-0.1,0.6-0.2,0.9l-5.5-5.4c-0.2-0.2-0.4-0.2-0.6,0 s-0.2,0.4,0,0.6l5.5,5.5c-0.3,0.2-0.7,0.4-1.1,0.4H10.2c-0.4,0-0.8-0.1-1.1-0.4l5.5-5.5c0.1-0.2,0.1-0.4,0-0.5 c-0.2-0.1-0.4-0.1-0.6,0L8.5,30c-0.1-0.3-0.2-0.6-0.2-0.9V17.9l3.9,3.3l5.4,4.5c1,0.8,2.5,0.8,3.5,0l5.4-4.5l3.9-3.3 C30.4,17.9,30.4,29.2,30.4,29.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.87ad1369f16b7a938de8107bf781bcf0.svg";
export { ForwardRef as ReactComponent };